import React, { Fragment, useEffect, useState } from 'react';
import { FaFutbol } from "react-icons/fa";
import { LoadingSpinner } from "../../components";
import goalResultService from "../../services/goalResultService";
import HeaderTitle from '../../components/HeaderTitle';
import { useWindowWidth } from '@react-hook/window-size';
import GoalResultMobile from './mobile/GoalResultMobile';

const title = ["909 Result", "555 Result"];

function GoalResult() {
  const onlyWidth = useWindowWidth();
  const [isLoading, setIsLoading] = useState(false);
  const [goalResultList, setGoalResultList] = useState([]);

  useEffect(() => {
    getAllGoalResult();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getAllGoalResult = async () => {
    try {
      setIsLoading(true);
      const goalResultList = await goalResultService.getAllGoals();

      if (goalResultList.data.status !== 403) {
        const sorttedValue = goalResultList.data.data.sort((a, b) => a.eventTime - b.eventTime);
        console.log("for", sorttedValue);
        const formattedValue = sorttedValue.map((v, i) => {
          let temp555HomeGoal = v.finished555.toLowerCase() === "true" ?
            v.canceled === "true" ? "PP" : v.homeGoal555 : 'NS';
          let temp555AwayGoal = v.finished555.toLowerCase() === "true" ?
            v.canceled === "true" ? "PP" : v.awayGoal555 : 'NS';
          return { ...v, isDiff: v.homeGoal909 !== temp555HomeGoal && v.awayGoal909 !== temp555AwayGoal }

        })
        setGoalResultList(formattedValue);
      }

    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Fragment>
      <div>
        <header className="bg-white dark:bg-custom_dark_background shadow mb-1">
          <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
            <div className="flex justify-between">
              <div className=''>
                <HeaderTitle title={"Goal Results Comparison"} />
              </div>
            </div>
            <div className="flex justify-between items-center w-[99%] gap-1">
              <div className="flex gap-2 items-center">
                <span className="font-bold"></span >
              </div>
              <div className="flex items-center">
              </div>
            </div>
          </div>
        </header>
        <main className="flex justify-center w-[100%]">
          {
            isLoading ? <LoadingSpinner />
              :
              onlyWidth < 480 ?
                <GoalResultMobile goalResultList={goalResultList} />
                : <table className="border-separate border-spacing-2 border border-slate-400 w-[100%] max-w-7xl dark:border-none">
                  <thead className='sticky top-0 z-10'>
                    <tr>
                      {
                        title && title.map((v, i) => {
                          return (
                            <th className="border border-slate-300 dark:border-custom_dark_primary py-3 w-[50%] bg-background dark:bg-custom_dark_primary2 text-white dark:text-customWhite" key={i}>{v}</th>
                          )
                        })
                      }
                      {/* <th className="border border-slate-300 py-3 px-1 w-[10%] bg-background text-white">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      goalResultList.length > 0 ? goalResultList.map((v, i) => {
                        return (
                          <tr key={i}>
                            <td className={`border border-slate-300 dark:border-custom_dark_primary pb-2 rounded-sm ${v.isDiff ? 'bg-yellow-300 dark:bg-customLightYellow2' : 'dark:bg-custom_dark_primary2'} `}>
                              <div className='flex justify-between py-0'>
                                <span className="text-sm flex items-center gap-1 text-customFontGreen ml-1"><FaFutbol />{v.eventTime}</span>
                                {/* {
                            (!v.finished555 && v.status909 === "0") || (v.homeGoal909 === v.homeGoal555 && v.awayGoal909 === v.awayGoal555) ?
                           null
                            : <Radio
                           checked={selectedValue === v.eventId909}
                           onChange={(e)=>handleChange(e.target.value,'909')}
                           value={v.eventId909}
                           name="radio-buttons"
                           inputProps={{ 'aria-label': v.eventId909 }}
                         />
                        } */}
                              </div>
                              <div className='flex'>
                                <div className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium dark:text-customOrange">{v.homeTeam909}</div>
                                <div className="flex justify-center w-[30%]">
                                  <b className={`text-lg ${v.homeGoal909 === "PP" ? "text-customFontRed" : v.isDiff ? "text-background dark:text-customBlack" : "text-background dark:text-customWhite" }`}>
                                    {v.homeGoal909}
                                  </b>
                                  <span className="justify-center bg-blue dark:bg-customLightYellow text-center text-white rounded px-2 mx-3">VS</span>
                                  <b className={`text-lg ${v.awayGoal909 === "PP" ? "text-customFontRed" : v.isDiff ? "text-background dark:text-customBlack" : "text-background dark:text-customWhite" }`}>
                                    {v.awayGoal909}
                                  </b>
                                </div>
                                <div className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium dark:text-customOrange">{v.awayTeam909}</div>
                              </div>
                            </td>
                            <td className={`border border-slate-300 dark:border-custom_dark_primary pb-2 rounded-sm ${v.isDiff ? 'bg-yellow-300 dark:bg-customLightYellow2' : 'dark:bg-custom_dark_primary2'} `} >
                              <div className='flex justify-between'>
                                <span className="text-sm flex items-center gap-1 text-customFontGreen ml-1"><FaFutbol />{v.eventTime}</span>
                                {/* {
                             (!v.finished555 && v.status909 === "0") || (v.homeGoal909 === v.homeGoal555 && v.awayGoal909 === v.awayGoal555) ?
                         null
                          :  <Radio
                          checked={selectedValue === v.eventId555}
                          onChange={(e)=>handleChange(e.target.value,'555')}
                          value={v.eventId555}
                          name="radio-buttons"
                          inputProps={{ 'aria-label': v.eventId555 }}
                        />} */}
                              </div>
                              <div className='flex'>
                                <span className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium dark:text-customOrange">{v.homeTeam555}</span>
                                <div className="flex justify-center w-[30%]">
                                  <b className={`text-lg ${v.finished555.toLowerCase() === "true" && v.canceled === "true" ? "text-customFontRed" : v.isDiff ? "text-background dark:text-customBlack" : "text-background dark:text-customWhite"}`}>
                                    {v.finished555.toLowerCase() === "true" ? v.canceled === "true" ? "PP" : v.homeGoal555 : 'NE'}
                                  </b>
                                  <span className="justify-center bg-blue dark:bg-customLightYellow text-center text-white rounded px-2 mx-3">VS</span>
                                  <b className={`text-lg ${v.finished555.toLowerCase() === "true" && v.canceled === "true" ? "text-customFontRed" : v.isDiff ? "text-background dark:text-customBlack" : "text-background dark:text-customWhite"}`}>
                                    {v.finished555.toLowerCase() === "true" ? v.canceled === "true" ? "PP" : v.awayGoal555 : 'NE'}
                                  </b>
                                </div>
                                <span className="flex justify-center w-[35%] text-sm text-customFontVoilet font-medium dark:text-customOrange">{v.awayTeam555}</span>
                              </div>
                            </td>
                            {/* <td className="border border-slate-300 px-2">
                        {
                           (v.finished555 === "false" && v.status909 === "0") || (v.homeGoal909 === v.homeGoal555 && v.awayGoal909 === v.awayGoal555) ?
                          <Button variant="contained" size='medium' disabled>Save</Button> :
                          <Button variant="contained" size='medium' onClick={()=>handleOpen(v.eventId909)}>Save</Button>
                        }
                      </td> */}
                          </tr>
                        )
                      }) : null
                    }
                  </tbody>
                </table>
          }

        </main>
      </div>
    </Fragment>
  )
}

export default GoalResult;



